import React,{useEffect,useState} from 'react';
import {analyticsChoice,setAnalyticsChoice,track} from '../analytics';
export default function AnalyticsPreferences(){
 const [choice,setChoice]=useState(analyticsChoice),[open,setOpen]=useState(false),[error,setError]=useState('');
 const choose=async enabled=>{
  setChoice(enabled?'yes':'no');setError('');
  try{await setAnalyticsChoice(enabled);setOpen(false);}catch{setError('המדידה הופסקה, אך מחיקת הנתונים הקודמים נכשלה. נסו שוב.');}
 };
 return <aside className="analytics-preferences" aria-label="העדפות מדידה">
  <button type="button" onClick={()=>setOpen(v=>!v)}>פרטיות ומדידה</button>
  {open&&<div><p>אפשר לעזור לשפר את Connext באמצעות מדידה אופציונלית של שימוש ותקלות שיחה. לא נאספים תוכן הודעות, הקלטות, נתוני פנים או מיקום מדויק. נתוני שיחות נשמרים עד 30 יום ונתוני שימוש עד 90 יום. הזיהוי הוא לפי הדפדפן, ללא שם או דוא״ל.</p>
  <p>אפשר להשתמש באפליקציה גם ללא מדידה. ביטול המדידה מוחק את הנתונים המשויכים לדפדפן הזה. לשימוש עתידי אחר תידרש בחינה והודעה נפרדת.</p>
  <button type="button" onClick={()=>choose(true)}>אישור מדידה</button>
  <button type="button" onClick={()=>choose(false)}>{choice==='yes'?'הפסקת מדידה ומחיקת הנתונים':'ללא מדידה / מחיקת נתונים'}</button>
  {error&&<p role="alert">{error}</p>}</div>}
 </aside>;
}

// Keep consented activity measurement independent of whether profile settings are open.
export function AnalyticsActivity(){
 const [choice,setChoice]=useState(analyticsChoice);
 useEffect(()=>{
  const refresh=()=>setChoice(analyticsChoice());
  window.addEventListener('analytics-choice-changed',refresh);
  window.addEventListener('storage',refresh);
  return()=>{window.removeEventListener('analytics-choice-changed',refresh);window.removeEventListener('storage',refresh);};
 },[]);
 useEffect(()=>{
  if(choice!=='yes')return undefined;
  track('active');
  const timer=setInterval(()=>{if(document.visibilityState==='visible')track('active');},30*60*1000);
  return()=>clearInterval(timer);
 },[choice]);
 return null;
}
